import BaseObjectStore from './base-object.store';

class BiometricReadinessStore extends BaseObjectStore {
  constructor(props) {
    super(props);
    this.name = 'biometricScore';
  }

  resetAllFields() {
    this.resetAllBaseFields();
  }
}

export default new BiometricReadinessStore();
